import React, { useEffect, useState } from "react";
import { API } from "@/lib/api";
import { FileText, ExternalLink, FileX2 } from "lucide-react";

export function PdfPreview({ bidId, kind = "filled", height = 520, label }) {
  const url = `${API}/bids/${bidId}/forms/${kind}`;
  const [ready, setReady] = useState(null); // null=checking, true/false

  useEffect(() => {
    let active = true;
    fetch(url, { method: "GET", credentials: "include" })
      .then((r) => active && setReady(r.ok && r.headers.get("content-type")?.includes("pdf")))
      .catch(() => active && setReady(false));
    return () => { active = false; };
  }, [url]);

  return (
    <div className="border border-zinc-200 rounded-sm overflow-hidden bg-zinc-50">
      <div className="px-3 py-2 border-b border-zinc-200 bg-white flex items-center justify-between">
        <span className="text-[10px] tracking-[0.1em] font-semibold text-zinc-500 flex items-center gap-1.5">
          <FileText className="h-3.5 w-3.5" /> {label || `SF-1442 — Ironclad ${kind}`}
        </span>
        {ready && (
          <a href={url} target="_blank" rel="noreferrer" data-testid={`open-pdf-${kind}`}
            className="text-[11px] text-zinc-500 hover:text-zinc-900 flex items-center gap-1 transition-colors">
            Open <ExternalLink className="h-3 w-3" />
          </a>
        )}
      </div>
      {ready === false ? (
        <div className="flex flex-col items-center justify-center text-center gap-2 text-zinc-400"
          style={{ height: Math.min(height, 200) }} data-testid={`pdf-empty-${kind}`}>
          <FileX2 className="h-6 w-6" />
          <span className="text-xs">SF-1442 {kind} PDF not generated yet</span>
        </div>
      ) : (
        <object data={url} type="application/pdf" className="w-full" style={{ height }} aria-label="SF-1442 PDF">
          <iframe title="SF-1442" src={url} className="w-full" style={{ height, border: 0 }} />
        </object>
      )}
    </div>
  );
}
